import React, { useEffect, useState } from 'react';
import {
  Container,
  Grid,
  Typography,
  Pagination,
  CircularProgress,
  Box,
} from '@mui/material';
import axios from 'axios';
import CourseCard from '../components/CourseCard';
import CategoryTabs from '../components/CategoryTabs';
import {axiosInstance} from "../axiosInstance.jsx"
import { useParams } from "react-router-dom";
import AdSense from "react-adsense";


const CoursesPage = () => {
let { page, category } = useParams();
page = page ? Number(page) : 1;
category = category ? category : 'All';
  const [courses, setCourses] = useState([]);
  const [total, setTotal] = useState(0);
  
  const [loading, setLoading] = useState(false);

  const { exp } = useParams();

  useEffect(() => {
    setLoading(true);
    const categoryParam = category === 'All' ? '' : `&category=${encodeURIComponent(category)}`;
    let url = `/courses?page=${page}${categoryParam}`;
    if (exp) {
      url += `&exp=${encodeURIComponent(exp)}`;
    }
    axiosInstance
      .get(url)
      .then((res) => {
        setCourses(res.data.courses);
        setTotal(res.data.total);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [page, category]);

  function handlePageChange(event, value) {
    // ? page = 1
    window.location.href = `/${category}/${value}`
    }
    

return (
    <Container maxWidth={false} sx={{ mt: 2, mb: 6, px: 4 }}>
       
        {!exp && <CategoryTabs selectedCategory={category}  />}

        {
            exp && (
                <Typography variant="h5" gutterBottom>
                    Filter Applied : <strong style={{"text-transform": "uppercase"}}>{(exp)}</strong>
                </Typography>
            )
        }

        {loading ? (
  <Box display="flex" justifyContent="center" my={6}>
    <CircularProgress />
  </Box>
) : (
  <Box
    sx={{
      width: '100%',
      minHeight: '1px',
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gap: '24px',
        gridTemplateColumns: {
          xs: 'minmax(0, 1fr)',
          sm: 'repeat(auto-fill, minmax(300px, 1fr))',
          md: 'repeat(auto-fill, minmax(350px, 1fr))',
          xl: 'repeat(auto-fill, minmax(300px, 1fr))',
        },
        justifyContent: 'flex-start',
        width: '100%',
        maxWidth: '100%',
      }}
    >
      {courses.map((course) => (
        <CourseCard key={course._id} course={course} />
      ))}
    </Box>
  </Box>
)}

        {!exp && <Box display="flex" justifyContent="center" mt={6} mb={8}>
            <Pagination
                count={Math.ceil(total / 15)}
                page={page}
                // onChange={(e, value) => setPage(value)}
                onChange={handlePageChange}
                color="primary"
            />
        </Box>}
    </Container>
);
};

export default CoursesPage;
